export const CLONE_DISPLAY_NAME = 'Clone';
